// 비속어/욕설 필터
// - badwords-ko: 한글 원형(씨발, 개새끼 등)에 강함
// - korcen: 초성/자모 변형(ㅅㅂ, ㅄ 등)에 강함
// 두 라이브러리를 OR로 결합하고, 관리자가 MongoDB에 추가한 단어는 포함(substring) 검사한다.
import { check } from "korcen";
import Filter from "badwords-ko";

// 기본 사전은 모듈 로드 시 1회만 생성해 재사용한다.
const koFilter = new Filter();

/**
 * 비속어 포함 여부
 * @param {string} text 검사할 문자열
 * @param {string[]} userWords 관리자가 추가한 금지어 목록(선택)
 * @returns {boolean} 비속어가 포함되면 true
 */
export function isProfane(text, userWords = []) {
  if (!text) return false;

  // 라이브러리 기본 사전
  if (koFilter.isProfane(text)) return true;
  if (check(text)) return true;

  // 관리자 추가 금지어(공백 우회 방지 위해 공백 제거본도 비교)
  if (Array.isArray(userWords) && userWords.length) {
    const stripped = text.replace(/\s+/g, "");
    for (const w of userWords) {
      if (!w) continue;
      const word = String(w);
      if (text.includes(word)) return true;
      const strippedWord = word.replace(/\s+/g, "");
      if (strippedWord && stripped.includes(strippedWord)) return true;
    }
  }

  return false;
}

export default isProfane;
